// Copyright (c) 2016 Deere & Company

import t from 'tcomb';

const DealerPercentage = t.struct({
    account: t.String,
    completePercentage: t.Number
}, {
    name: 'DealerPercentage',
    strict: true
});

export const getDefaultState = () => new DealerPercentage({
    account: '',
    completePercentage: 0
});

export default DealerPercentage;



// WEBPACK FOOTER //
// ./~/@deere/cps-it.warranty-model-factory/lib/dealer-percentage.js